var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeachVolleyball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0564 10.4793C18.317 11.9032 16.1182 12.6711 15.4849 12.8723C14.9524 12.4015 13.0759 10.8221 10.9549 10.0062C10.0955 9.67475 9.29099 9.50789 8.56416 9.51019C7.9996 9.51248 7.47848 9.61533 7.00537 9.81646C6.90481 9.85989 6.80881 9.9056 6.71281 9.95817C6.61225 10.013 6.51397 10.0724 6.41797 10.1364C6.47054 9.96045 6.52768 9.78675 6.58939 9.61306C6.86595 8.8428 7.23624 8.1114 7.69104 7.43489C7.83046 7.35717 7.97445 7.28632 8.12072 7.22233C8.25557 7.1629 8.39271 7.10804 8.53441 7.06005C10.3629 6.4178 12.6416 6.66235 15.3318 7.79144C17.4574 8.68052 19.2333 9.88047 20.0562 10.4793L20.0564 10.4793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7992 8.45187C21.5066 8.99586 21.0975 9.51924 20.581 10.0152C19.7947 9.43465 17.8954 8.12044 15.5983 7.15592C14.1081 6.52968 12.7047 6.15939 11.4293 6.05653C10.7048 5.99711 10.0168 6.02453 9.37229 6.13653C9.23515 6.15939 9.1003 6.18681 8.96774 6.21881C8.82603 6.2531 8.68661 6.28967 8.55176 6.33081C8.56776 6.31252 8.58604 6.29424 8.60204 6.27595C8.70718 6.15939 8.81917 6.04282 8.93117 5.92854C9.68087 5.17884 10.5288 4.56406 11.4476 4.0932C11.7425 4.02692 12.035 3.97892 12.323 3.94464C12.6018 3.91264 12.8738 3.89436 13.1458 3.88979C17.5777 3.82122 20.8618 7.32733 21.7993 8.45201L21.7992 8.45187Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1083 7.75724C21.114 6.62814 18.721 4.26712 15.471 3.47169C15.2173 3.40998 14.959 3.35741 14.6962 3.31627C14.431 3.27513 14.159 3.24313 13.8848 3.22485C14.5225 3.08771 15.1807 3.01229 15.8458 3.00086C16.0218 2.99857 16.2001 3.00086 16.3738 3.00771C16.3989 3.00771 16.4218 3.01 16.4469 3.01C18.584 3.10371 20.6136 3.87396 22.2638 5.20188C22.2867 5.31845 22.3072 5.43273 22.3232 5.54701C22.3392 5.659 22.3507 5.771 22.3575 5.88071C22.4032 6.52981 22.321 7.15835 22.1084 7.75717L22.1083 7.75724Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28372 17.4208C7.34772 17.7111 7.42314 17.9991 7.51 18.2848C6.60717 16.838 6.08608 15.1741 6.01064 13.4438C6.00836 13.389 6.00607 13.3318 6.00379 13.2701C5.99922 13.1284 5.99922 12.9844 6.0015 12.8404C6.01064 12.3147 6.05864 11.7913 6.14778 11.2771C6.24149 11.1697 6.33749 11.0737 6.43805 10.9822C6.53176 10.8977 6.62776 10.82 6.72604 10.7491C7.10545 10.4794 7.53057 10.308 8.00597 10.2348C7.71799 10.9022 7.31115 12.0428 7.12375 13.469C6.99118 14.4906 6.9889 15.5077 7.12146 16.4997C7.13518 16.5957 7.14889 16.6894 7.1626 16.7854C7.19689 17.0002 7.23803 17.2105 7.28374 17.4208L7.28372 17.4208Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4148 22.337C11.1829 21.8639 10.047 21.1485 9.07784 20.216C8.94756 19.9829 8.82642 19.7497 8.71672 19.512C8.60015 19.2675 8.49501 19.0184 8.39902 18.7692C7.76818 17.1213 7.56707 15.3751 7.80475 13.5604C8.01502 11.9445 8.52473 10.7263 8.77612 10.1983C9.2904 10.2212 9.84805 10.34 10.4469 10.548C10.3349 11.2749 10.1132 13.0576 10.2481 15.2014C10.3395 16.6619 10.5841 18.0241 10.9681 19.2537C11.2423 20.1246 11.5874 20.9314 12.0034 21.6673C12.0674 21.7816 12.136 21.8959 12.2045 22.0079C12.2731 22.1199 12.3417 22.2296 12.4148 22.337L12.4148 22.337Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6038 22.872C17.1855 22.9406 16.7604 22.9817 16.333 22.9954C16.2256 23 16.1158 23 16.0039 23C15.9216 23 15.8393 23 15.757 22.9977C15.693 22.9954 15.6244 22.9931 15.5559 22.9909C14.8656 22.9611 14.1868 22.8583 13.5263 22.6914C13.4463 22.5932 13.3686 22.4926 13.2909 22.392C13.2154 22.2915 13.1423 22.1886 13.0692 22.0858C11.8281 20.287 11.1081 17.9625 10.9321 15.1605C10.8087 13.2155 10.9893 11.5835 11.1012 10.8089C12.9114 11.6021 14.5159 12.9391 15.0096 13.3711C14.9297 13.6728 14.7902 14.2648 14.7057 15.0396C14.596 16.0681 14.5685 17.6246 15.0736 19.1948C15.3616 20.0931 15.7959 20.9136 16.3604 21.629C16.5981 21.9284 16.8587 22.2118 17.1444 22.4793C17.2176 22.5478 17.2907 22.6141 17.3684 22.6804C17.4461 22.7444 17.5238 22.8084 17.6038 22.8724L17.6038 22.872Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6147 15.7683C25.153 17.3797 24.2867 18.8585 23.0731 20.0722C22.9588 20.1865 22.8422 20.2985 22.7257 20.4037C22.5954 20.5225 22.4605 20.6391 22.3257 20.7488C21.4686 21.4505 20.5086 21.999 19.4733 22.383C19.1533 22.5019 18.8287 22.6024 18.4996 22.687C18.4173 22.6299 18.335 22.5727 18.255 22.511C18.175 22.4516 18.0996 22.3922 18.0242 22.3304C17.7431 22.1042 17.4825 21.8619 17.2471 21.6036C18.127 21.3499 19.7361 20.7991 21.4 19.7957C22.6068 19.0688 23.6422 18.2255 24.481 17.2884C24.5199 17.2427 24.561 17.1992 24.5999 17.1535C24.7896 16.9341 24.9701 16.7101 25.137 16.4793C25.3061 16.2461 25.4661 16.0084 25.6147 15.7684L25.6147 15.7683Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9973 9.17867C24.9859 9.33409 24.9631 9.48722 24.9356 9.64266C24.1494 13.9169 17.4432 17.6491 15.6127 18.5953C15.2652 17.2788 15.2927 16.0012 15.3864 15.1281C15.4664 14.3784 15.6035 13.8024 15.6767 13.5304C15.9669 13.439 16.5772 13.2333 17.3291 12.8996C18.2937 12.4745 19.6833 11.7477 20.833 10.7146C21.5781 10.0449 22.1426 9.32035 22.5152 8.55694C22.826 7.91925 23.0043 7.24958 23.0455 6.55932C23.0523 6.45189 23.0546 6.34447 23.0569 6.23705C23.0569 6.12505 23.0546 6.01306 23.0477 5.90106L23.0752 5.92849C23.8752 6.72847 24.5266 7.64956 25.0111 8.64835C25.0156 8.82663 25.0111 9.00262 24.9974 9.17863L24.9973 9.17867Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9987 13.2402V13.2607C25.9164 13.5327 25.8227 13.7979 25.7175 14.0539C25.6147 14.3076 25.5004 14.5521 25.3793 14.7876C23.1622 19.0777 18.0356 20.6843 16.7672 21.0228C16.3741 20.4903 16.0564 19.8983 15.8232 19.2583C16.7741 18.7737 19.0231 17.5555 21.1532 15.8528C22.5383 14.7465 23.6262 13.6312 24.3828 12.5363C24.7782 11.9672 25.0821 11.4004 25.3016 10.8404C25.3518 10.7101 25.3976 10.5799 25.4387 10.4496C25.4844 10.3102 25.5233 10.1685 25.5553 10.0291C25.8067 10.8404 25.9552 11.6861 25.9941 12.5524C25.9964 12.5866 25.9964 12.6209 25.9987 12.6575C26.0032 12.8541 26.0032 13.0506 25.9987 13.2403L25.9987 13.2402Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.75,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.75,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.25,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.25,
    cy: 26.5,
    r: 0.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.25,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.25,
    cy: 28.5,
    r: 0.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachVolleyball);
export default __webpack_public_path__ + "static/media/BeachVolleyball.94e48f5ba3f05cafc3015ffafdf5838e.svg";
export { ForwardRef as ReactComponent };